import { FC } from 'react';
import Box from '@/components/UI/box/Box';
import IconButton from '@/components/UI/iconButton/IconButton';
import Typography from '@/components/UI/typography/Typography';
import styles from './IncrementStepper.module.scss';
interface IncrementStepperType {
  format: 'base' | 'outline';
  handleChange: (type: 'increase' | 'decrease') => void;
  value: number;
  label: string;
  minimumValue?: number;
  maximumValue?: number;
  showValue?: boolean;
  disabled?: boolean;
}
const IncrementStepper: FC<IncrementStepperType> = ({
  format,
  handleChange,
  value,
  label,
  minimumValue = 0,
  showValue = true,
  maximumValue = 10,
  disabled = false
}) => {
  return <Box className={`${styles['stepper-container']} ${styles[format]}`} data-sentry-element="Box" data-sentry-component="IncrementStepper" data-sentry-source-file="IncrementStepper.tsx">
      <IconButton icon="add" format="tonal" onClick={() => {
      if (value < maximumValue) handleChange('increase');
    }} disabled={value >= maximumValue || disabled} data-sentry-element="IconButton" data-sentry-source-file="IncrementStepper.tsx" />

      <Typography variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="IncrementStepper.tsx">
        {showValue ? value : `${value} ${label}`}
      </Typography>
      <IconButton icon="minus" format="tonal" onClick={() => {
      if (value > minimumValue) handleChange('decrease');
    }} disabled={value <= minimumValue || disabled} data-sentry-element="IconButton" data-sentry-source-file="IncrementStepper.tsx" />
    </Box>;
};
export default IncrementStepper;